/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Newsletter_Unsubscribe_Meta_TitleInputs */

const ja_playdata_newsletter_unsubscribe_meta_title = /** @type {(inputs: Playdata_Newsletter_Unsubscribe_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配信停止`)
};

const en_playdata_newsletter_unsubscribe_meta_title = /** @type {(inputs: Playdata_Newsletter_Unsubscribe_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsubscribe`)
};

/**
* | output |
* | --- |
* | "Unsubscribe" |
*
* @param {Playdata_Newsletter_Unsubscribe_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_newsletter_unsubscribe_meta_title = /** @type {((inputs?: Playdata_Newsletter_Unsubscribe_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Newsletter_Unsubscribe_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_newsletter_unsubscribe_meta_title(inputs)
	return en_playdata_newsletter_unsubscribe_meta_title(inputs)
});